"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getServerURL = void 0;
const getServerURL = (appName, path) => {
  let appPort = '';
  switch (appName) {
    case 'WEDDING':
      appPort = ':9003';
      break;
    case 'BABY':
      appPort = ':9004';
      break;
    case 'NAV':
      appPort = ':9005';
      break;
    case 'REGISTRY':
      appPort = ':9006';
      break;
    case 'PREAUTH':
      appPort = ':9009';
      break;
    case 'MARKETPLACE':
      appPort = ':9008';
      break;
    default:
  }
  const PORT = process.env.ZOLA_ENV === 'production' ? '' : appPort;
  return `${process.env.WEB_HOST}${PORT}${path}`;
};
exports.getServerURL = getServerURL;